import { NgModule } from '@angular/core';
import { LatLongPipe } from "./lat-long.pipe";
import { CommonModule } from "@angular/common";
import { RadiusPipe } from "./radius.pipe";


@NgModule({
    imports: [
        CommonModule
    ],
    exports: [
        LatLongPipe,
        RadiusPipe
    ],
    declarations: [
        LatLongPipe,
        RadiusPipe
    ],
    providers: [],
})
export class GeoPositionPipesModule {
}
